








































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { Apis, Factories } from '@finx/web-repository'
import Api from '@/Apis/_'
import Moment from 'moment'
import 'moment-timezone'
import _ from 'lodash'

import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import { NumberMixin, DateMixin } from '@finx/web-repository/src/mixin/_'
import { Loading } from '@/types/_'
import { isRolesValid } from '@/utils/common'

@Component({
  mixins: [DateMixin, NumberMixin],
})

export default class ViewDashboard extends Vue {
  get formatarValorTotal() {
    // @ts-ignore
    return this.formatDecimalNumber(this.total, 2, '.', ',')
  }

  chatOff: boolean = false
  data: any = null
  mesesExibir: number = 3
  ocultarValor: any = {
    exibir: true,
    classe: 'icon-shape-eye-close',
  }

  dataSelecionada: any = null
  localExecucao: Array<any> = []
  operadora: Array<any> = []
  fontePagadora: Array<any> = []
  recebimento: Array<any> = []
  recebimentoFuturo: Array<any> = []
  total: Number = 0
  nomeExecutante: String = ''
  descricaoDedicacao: String = ''

  mounthSelected: String = ''
  yearSelected: String = ''

  valoresReceber: [] = []
  valoresRecebido: any = {}
  valoresPendente: [] = []
  // producaoSemRepasse: [] = []
  producaoSemRepasse: Array<{ date: Date | string, total: number }> = [
    {
      date: '2023-08-31T00:00:00',
      total: 1539,
    },
    {
      date: '2023-09-30T00:00:00',
      total: 25,
    },
    {
      date: '2023-10-30T00:00:00',
      total: 15,
    },
  ]

  loading: Loading = {
    status: true,
    text: 'Carregando...',
  }

  async dataSelecionadaChange() {
    this.loading.status = true
    const mes = this.dataSelecionada.substring(0, this.dataSelecionada.indexOf('/'))
    const ano = this.dataSelecionada.substring(this.dataSelecionada.indexOf('/') + 1)

    this.mounthSelected = mes
    this.yearSelected = ano

    await this.selecionarPeriodo(Moment(`${ano}-${mes}-01`, 'YY-MMM-DD', 'pt-br').toDate())
    this.loading.status = false
  }

  async onDataSelecionadaChange() {
    const mes = this.dataSelecionada.substring(0, this.dataSelecionada.indexOf('/'))
    const ano = this.dataSelecionada.substring(this.dataSelecionada.indexOf('/') + 1)

    this.mounthSelected = mes
    this.yearSelected = ano

    await this.selecionarPeriodo(Moment(`${ano}-${mes}-01`, 'YY-MMM-DD', 'pt-br').toDate())
  }

  formatarData(data) {
    return Moment(data).format('MMM/YY')
  }

  async getUser() {
    return this.$user
  }

  get getChatOff() {
    return this.chatOff
  }

  set getChatOff(value) {
    this.chatOff = value
  }

  async Init() {
    this.ocultarValor = {
      exibir: true,
      classe: 'icon-shape-eye-close',
    }

    let dataCorrente = new Date()
    // @ts-ignore
    dataCorrente = this.truncateTime(this.firstDayOfMonth(dataCorrente))
    this.dataSelecionada = `${Moment(dataCorrente).locale('pt-br').format('MMM').toUpperCase()}/${Moment(dataCorrente).format('YY')}`
    await this.onDataSelecionadaChange()

    // @ts-ignore
    const dataInicial = this.firstDayOfMonth(dataCorrente)
    dataInicial.setHours(0)
    dataInicial.setMinutes(0)
    dataInicial.setSeconds(0)
    dataInicial.setMilliseconds(0)

    let dataFinal = Moment(dataInicial).add(5, 'months').toDate()
    // @ts-ignore
    dataFinal = this.lastDayOfMonth(dataFinal)
    dataFinal.setHours(23)
    dataFinal.setMinutes(59)
    dataFinal.setSeconds(59)

    const mes = this.dataSelecionada.substring(0, this.dataSelecionada.indexOf('/'))
    const ano = this.dataSelecionada.substring(this.dataSelecionada.indexOf('/') + 1)

    this.data = Moment(`${ano}-${mes}-01`, 'YY-MMM-DD', 'pt-br').toDate()
  }

  get listaMeses() {
    let dataCorrente = new Date()
    // @ts-ignore
    const dataFinal = this.truncateTime(this.firstDayOfMonth(dataCorrente))
    const dataInicial = Moment(dataFinal).add(-11, 'M').toDate()

    const listaMeses = []
    dataCorrente = dataFinal

    while (dataCorrente >= dataInicial) {
      // @ts-ignore
      listaMeses.push(`${Moment(dataCorrente).locale('pt-br').format('MMM').toUpperCase()}/${Moment(dataCorrente).format('YY')}`)
      // @ts-ignore
      dataCorrente = this.truncateTime(this.firstDayOfMonth(Moment(dataCorrente).add(-1, 'M').toDate()))
    }
    return listaMeses
  }

  ocultar(event) {
    if (this.ocultarValor.classe === 'icon-shape-eye-close') {
      this.ocultarValor.classe = 'icon-shape-olho-aberto'
      this.ocultarValor.exibir = false
    } else {
      this.ocultarValor.classe = 'icon-shape-eye-close'
      this.ocultarValor.exibir = true
    }
  }

  async selecionarPeriodo(data) {
    // @ts-ignore
    const dataInicial = this.firstDayOfMonth(data)
    dataInicial.setHours(0)
    dataInicial.setMinutes(0)
    dataInicial.setSeconds(0)
    dataInicial.setMilliseconds(0)

    // @ts-ignore
    const dataFinal = this.lastDayOfMonth(data)
    dataFinal.setHours(23)
    dataFinal.setMinutes(59)
    dataFinal.setSeconds(59)
    dataFinal.setMilliseconds(999)

    const resultLista = async () => {
      const result = await ApiLegacy
        // @ts-ignore
        .Recebimento.getRecebimentos(this.tranformDate2Epoch(dataInicial),
        // @ts-ignore
          this.tranformDate2Epoch(dataFinal))

      if (result.status === 200) {
        this.total = result.data.data.valorTotal
        this.fontePagadora = result.data.data.fontePagadora
        this.operadora = result.data.data.operadora
        this.localExecucao = result.data.data.localExecucao
        this.nomeExecutante = result.data.data.nomeExecutante
        this.descricaoDedicacao = result.data.data.descricaoDedicacao
      }
    }

    await resultLista()
  }

  async valoresReceberLoad() {
    const request = await Apis.Legacy.Recebimento.getValoresReceber(this.mesesExibir)
    const success = Factories.Apis.success(request)

    if (success && request.data !== '') {
      this.valoresReceber = request.data
    }
  }

  async valoresRecebidoLoad() {
    const request = await Apis.Legacy.Recebimento.getValoresRecebidos(this.mesesExibir)
    const success = Factories.Apis.success(request)

    if (success && request.data !== '') {
      this.valoresRecebido = request.data
    }
  }

  async valoresPendenteLoad() {
    const request = await Apis.Legacy.Recebimento.getValoresPendentes(this.mesesExibir)
    const success = Factories.Apis.success(request)

    if (success && request.data !== '') {
      this.valoresPendente = request.data
    }
  }

  async getTemplate() {
    const request = await Api.Legacy.RecebimentoApi.getRelatorioTemplate()
    this.template = request.success ? request.data : this.template
  }

  async getProducaoSemRepasse() {
    const request = await Api.Legacy.RecebimentoApi.getRelatorioProducaoSemRepasse(this.mesesExibir)
    this.producaoSemRepasse = request.success ? request.data : this.producaoSemRepasse
  }

  async getRelatorioRecebimento(start, end) {
    const request = await ApiLegacy.Reports.getRecebimento(start, end)
    const success = Factories.Apis.success(request)

    if (success) {
      this.recebimento = request.data.data
    }
  }

  template: any = {
    valoresReceber: true,
    valoresRecebidos: true,
    valoresPendentes: true,
    producaoSemRepasse: false,
  }

  async mounted() {
    this.loading.status = true
    const dateStart = Moment(new Date()).subtract(6, 'months').startOf('month').format('YYYY-MM-DD')
    const dateEnd = Moment(new Date()).add(6, 'months').endOf('month').format('YYYY-MM-DD')
    await this.Init()

    await this.getTemplate()

    if (this.template.valoresReceber) await this.valoresReceberLoad()
    if (this.template.valoresRecebidos) await this.valoresRecebidoLoad()
    if (this.template.valoresPendentes) await this.valoresPendenteLoad()
    if (this.template.producaoSemRepasse) await this.getProducaoSemRepasse()

    const user = await this.getUser()
    this.getChatOff = !isRolesValid(user.profile, 'chatOff')
    this.loading.status = false
  }
}
